import { createReducer } from '@reduxjs/toolkit'
import { BimObject, BimViewMode } from '../models/Bim'
import {
  setBimObjects,
  resetBimState,
  setSelectedBimObjectId,
  addBimObjects,
  changeViewMode,
} from '../actions/bim'

interface BimState {
  objects: BimObject[]
  viewMode: BimViewMode
  selectedBimObjectId?: string | null
}

const initialState: BimState = {
  objects: [],
  viewMode: BimViewMode.Image,
}

const bimReducer = createReducer(initialState, (builder) => {
  builder.addCase(setBimObjects, (state, action) => {
    state.objects = action.payload
  })
  builder.addCase(addBimObjects, (state, action) => {
    action.payload[0].isNonEditable = true
    state.objects = [...state.objects, ...action.payload]
  })
  builder.addCase(setSelectedBimObjectId, (state, action) => {
    state.selectedBimObjectId = action.payload
  })
  builder.addCase(changeViewMode, (state, action) => {
    state.viewMode = action.payload
  })
  builder.addCase(resetBimState, (state, action) => {
    state = initialState
  })
})

export default bimReducer
